// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__iiQ9M","inputs":"styles_inputs__eEveK"};